import '../../scss/forms.scss';
import '../../scss/modal.scss';
import './_style.scss';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import 'react-select/dist/react-select.min.css';
import 'react-toastify/dist/ReactToastify.css';
import {getUserProperty, redirectHandled } from '../../util/helper';
import React from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { connect } from 'react-redux';
import Select from 'react-select';
import {
  FiltroDinamico,
  GridDinamico,
  dynamicFilterStore,
  clear,
} from '@newspacebpo/newspace-react-grid-filter-bfveic';

import { toast } from 'react-toastify';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Collapse,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap';
import { bindActionCreators } from 'redux';

import PrintCapa from '../printCapa';
import * as storage from '../../services/storage';
import * as trackTime from '../../services/tracking-time';
import * as RecepcionarActions from '../../store/ducks/protocolo/recepcao/recepcionar/actions';
import * as RecepcaoContratosActions from '../../store/ducks/protocolo/recepcao_contrato/actions';
import { dateToBr } from '../../util/date';

const inputFocusBy = (name)  => {
  const input = document.getElementsByName(name)[0];
  if(input) input.focus();
};


class RecepcaoContrato extends React.Component {
  constructor(props) {
    super(props);


    this.state = {
      primaryDisable: new Array(3).fill(false),
      showPesquisa: false,
      contratoSelecionado: null,
      contratosLista: [],
      contratosRecepcionados: [],
      contratosFaltantes: [],
      redirect: false,
      url: '/recepcao',
      show_recepcionados: false,
      dados: [],
      modalFinalizarRecepcao: false,
      numero_protocolo: this.props.match ? this.props.match.params.mode : '',
      qtd_originais: 0,
      protocolo_id: this.props.recepcao.idProtocolo,
      protocolo: this.props.recepcao.protocolo,
      dataGeracao: this.props.recepcao.dataGeracao,
      responsaveis: {},
      tipoEnvio: this.props.recepcao.tipoEnvio,
      etiqueta: this.props.recepcao.etiqueta,
      totalPaginas: 0,
    };
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (this.props.data.redirectFinalizacao) {
      this.redirectFinalizar();
    }

    if(this.state.contratosRecepcionados.length != prevState.contratosRecepcionados.length){
      this.sumPaginas();
    }
  };

  componentWillReceiveProps = nextProps => {
    if (
      JSON.stringify(nextProps.data.contratos) !==
      JSON.stringify(this.props.data.contratos)
    ) {
      /* Ja deixar selecionado se for apenas um elemento */
      if (nextProps.data.contratos.length === 1) {
        const contrato = nextProps.data.contratos[0];
        if (!this.checkRecepcionado(contrato.id)) {
          setTimeout(() => {
            let element = document.querySelector('.contratos_table tbody tr');
            element.click();
          }, 0);
        }
      }
    }
  };

  componentDidMount(){
    if(!this.props.recepcao.idProtocolo) this.props.recepcaoActions.searchRequest(this.props.match.params.mode);
    trackTime.start(`recepcao-${this.state.numero_protocolo}`)
    document.addEventListener("keydown", this.handleKeyEnter);
    
    this.props.actions.searchUsuarioRequest()
    this.carregasContratosStorage();
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyEnter);
  }

  carregasContratosStorage = () => {
    const incluidoLocal = storage.getItem('contratosRecepcionados-'+this.state.numero_protocolo);
    if (!!incluidoLocal) {
        this.setState({
          contratosRecepcionados: incluidoLocal,
        });
    };
  }

  openModalFinalizarRecepcao = () => {
    this.setState({
      modalFinalizarRecepcao: !this.state.modalFinalizarRecepcao
    });
  };

  tratarProposta = (cel, row) => {
    let numero = row.numero !== "" ? row.numero : row.proposta;
    return numero;
  }

  handleKeyEnter = event => {
    if (event.key === 'Enter') {
      const { data } = dynamicFilterStore.getState().dynamicFilters;
      const contratosSelecionados = data.filter((el) => el.isSelected);
      if(contratosSelecionados.length === 1) this.recepcionar();
    }
  };

  pesquisar = () => {
    let fields = {};

    if (this.contrato && this.contrato.value !== '')
      fields['contrato'] = this.contrato.value;
    if (this.cpfcnpj && this.cpfcnpj.value !== '')
      fields['cpf'] = this.cpfcnpj.value.replace(/\D/g, '');
    if (this.proposta && this.proposta.value !== '')
      fields['proposta'] = this.proposta.value;

    if (Object.keys(fields).length === 0) {
      toast.error('Selecione pelo menos um filtro.');
      return false;
    }

    if (!this.qtd_originais.value) {
      toast.error('Selecione a quantidade de páginas originais');
      return false;
    }
    if(this.qtd_originais.value<=0) {
      toast.error("Quantidade de paginas originais deve ser maior que 0")
      return false;
    }
    fields['idProtocolo'] = this.props.recepcao.idProtocolo;
    this.props.actions.searchRequest(this.state.numero_protocolo, fields);
    this.setState({ showPesquisa: true });
  };

  recepcionar = () => {
    const contr = this.state.contratosRecepcionados;    
    const { data, searchFilters: { qtdOriginais, qtdCopias }, } = dynamicFilterStore.getState().dynamicFilters;
    const contratosSelecionados = data.filter((el) => el.isSelected);
    let contratoSelecionado = {};
    if (contratosSelecionados.length === 0) {
      toast.warning('Selecione um contrato para poder recepcionar');
      return false;
    }else{
      contratoSelecionado = {...contratosSelecionados[0]};
      if (contratosSelecionados.length > 1) {
        toast.error(`Recepção de um contrato por vez.`)
        return false;
      }else if (contratoSelecionado.Recepcionado){
        toast.error(`Contrato já recepcionado`)
        return false;
      }else if(contr.some(item => item.IdContrato === contratoSelecionado.IdContrato)) {
        toast.error('Contrato já recepcionado');
        return false;
      }
    }
      
    contratoSelecionado.qtdOriginais = qtdOriginais ? parseInt(qtdOriginais) : 0;
    contratoSelecionado.qtdCopias = qtdCopias ? parseInt(qtdCopias) : 0;

    this.setState({...contratoSelecionado});
    contr.unshift({...contratoSelecionado});

    storage.setItem('contratosRecepcionados-'+this.state.numero_protocolo, contr);
    this.setState({ contratosRecepcionados: contr });
    this.limpar();
    this.sumPaginas();
  };

  convertObj = (item) => {

    return item.map((i) => ({
      _iddossie: i.IdContrato,
      nome_cliente: i.Nome,
      cpfcnpj: i.CPFCNPJ,
      qtd_originais: i.qtdOriginais,
      qtd_copias: i.qtdCopias,
      protocolo: this.state.protocolo,
      contrato: i.NumeroContrato,
      proposta: i.NumeroProposta,
      responsavel_preparacao: '',
      tipoEnvio: this.state.tipoEnvio,
      numero_etiqueta: i.CodigoEtiqueta
    }));
  }

  finalizarRecepcao = () => {
    if (!this.state.responsaveis.value) {
      toast.error('O campo responsável é obrigatório.');
      return false;
    }
    
    if (!this.caixa_original.value) {
      toast.error('Digite o número da caixa original.');
      return false;
    }
    if (!this.state.contratosRecepcionados.length) {
      toast.error('Recepcione pelo menos um contrato.');
      return false;
    }

    const copias = this.state.contratosRecepcionados.reduce((acum, el) => {
      return acum + el.qtdCopias
    }, 0);
    if( copias && !this.caixa_copia.value ) {
      toast.error('Digite o número da caixa cópia.');
      return false;
    }

    if (this.checkFinalizarRecepcao()) {
      this.recepcionarProtocolo();
    } else {
      this.openModalFinalizarRecepcao();
    }
  };

  checkFinalizarRecepcao = () => {
    const contratos = this.props.recepcao.dossies;
    const contratosRecepcionados = this.state.contratosRecepcionados;

    let contratosFaltantes = contratos.filter(x => {
      return !contratosRecepcionados.map(c => c.id).includes(x.id);
    });

    if (contratosFaltantes.length > 0) {
      this.setState({ contratosFaltantes: contratosFaltantes });
      return false;
    }
    return true;
  }

  recepcionarProtocolo = () => {
    const paginas = this.state.contratosRecepcionados.reduce((acum, el) => {
      acum.originais = el.qtdOriginais;
      acum.copias = el.qtdCopias;
      return acum;
    }, {originais:0, copias:0});
    
    let result = {
      idProtocolo: this.props.recepcao.idProtocolo,
      numero_protocolo: this.state.numero_protocolo,
      contratos: this.convertObj(this.state.contratosRecepcionados),
      caixa_originais: this.caixa_original.value,
      caixa_copias: this.caixa_copia.value,
      qtd_originais: paginas.originais,
      qtd_copias: paginas.copias,
      total_protocolo: this.props.recepcao.totalContratos,
      total_recepcionado: this.state.contratosRecepcionados.length,
      responsavel_preparacao: this.state.responsaveis.value
    };

    let dadosAdd = {
      responsavel_preparacao: this.state.responsaveis.value.nome,
      caixa_original: this.caixa_original.value,
      caixa_copia: this.caixa_copia.value,
      etiqueta: this.state.etiqueta,
      dataRecepcao: new Date(),
    };

    trackTime.stop(`recepcao-${result.numero_protocolo}`);
    this.props.actions.recepcionarRequest(result);
  };

  redirectFinalizar = () => {
    trackTime.reset(`recepcao-${this.state.numero_protocolo}`);
    storage.removeItem('contratosRecepcionados-'+this.state.numero_protocolo);
    window.print();
    this.limpar()
    toast.success('Recepção do protocolo '+this.state.numero_protocolo+' realizada com sucesso!')
    redirectHandled(this.props.history, this.state.url)
  }

  limpar = () => {
    this.setState({ contratoSelecionado: null });
    this.props.actions.clear();
    clear();
    const { configs: { filtros }, } = dynamicFilterStore.getState().dynamicFilters;
    if(filtros && filtros.some(el => el.focus)) inputFocusBy(filtros.find(el => el.focus).name);
  };

  checkRecepcionado = Contratos => {
    let contr = this.state.contratosRecepcionados;
    const find_recepcionados = contr.find(
      contrato => contrato._iddossie === id_contrato
    );

    if (find_recepcionados) {
      return true;
    }

    return false;
  };

  handleToggleDisable = (element, index) => {
    let newSet = new Array(3).fill(false);

    if (element && element.value.length > 0) {
      newSet = this.state.primaryDisable.map(function(elem, i, array) {
        if (i === index) return false;
        return true;
      });
    }

    this.setState({ primaryDisable: newSet });
  };

  sumPaginas = () => {
    const paginas = this.state.contratosRecepcionados.reduce((acum, el) => {
      acum.originais += el.qtdOriginais;
      acum.copias += el.qtdCopias ? el.qtdCopias : 0;
      return acum;
    }, {originais:0, copias:0})
    console.log("Total Páginas: ", paginas);
    this.setState({
      ...this.state,
      totalPaginas: (parseInt(paginas.originais) + parseInt(paginas.copias)),
    });
  };

  toggleShowRecepcionados = () => {
    this.setState({
      show_recepcionados: !this.state.show_recepcionados
    });
  };

  clearValue = e => {
    if (!e.target) return;
    e.target.value = e.target.value.toString().replace(/\D/g, '');
  };

  onKeyUp = e => {
    this.sumPaginas();
    this.clearValue(e);
    this.handleToggleDisable.bind(this, this.proposta, 1);
  };

  cssRowColors = (row) => {
    return row.Recepcionado || this.state.contratosRecepcionados.some(contrato => contrato.IdContrato === row.IdContrato) 
    ? 'contrato_recepcionado' 
    : row.isSelected ? 'contrato_selecionado' : '';
}  

  render() {
    const {responsaveis} = this.state;
    const {usuarios} = this.props.data;
    if (this.state.redirect && this.state.url) { 
      redirectHandled(this.props.history, this.state.url)
    }
    const { configs: { cesta } } = dynamicFilterStore.getState().dynamicFilters;
    const dadosAdicionais = {
      protocolo: this.state.numero_protocolo,
      caixaCopia: this.caixa_copia && this.caixa_copia.value || '',
      caixaOriginal: this.caixa_original && this.caixa_original.value || '',
    };
    const user = getUserProperty();
    return (
      <div className="recepcao-protocolo">
        <PrintCapa
          itens={this.state.contratosRecepcionados}
          chavesDados={cesta || []}
          dadosAdicionais={dadosAdicionais}
          hasCopy={
            this.caixa_copia && this.caixa_copia.value !== '' ? true : false
          }
          users={{recepcao: { name: user.name }, preparacao: {name: this.state.responsaveis.value && this.state.responsaveis.value.nome}}}
        />
        <Modal
          isOpen={this.state.modalFinalizarRecepcao}
          className="modal-contrato"
        >
          <ModalHeader>Existem contrato(s) não recepcionados</ModalHeader>
          <ModalBody>
            <p className="text-alert">
              Esse(s) contrato(s) ainda não foram recepcionados para esse
              protocolo, deseja finalizar mesmo assim?
            </p>
            <Row className="row_protocolo">
              <Col>
                <BootstrapTable
                  class="cor_azul"
                  data={this.state.contratosFaltantes}
                  version="4"
                  striped
                  pagination
                  options={this.options_recepcionados}
                >
                  <TableHeaderColumn isKey dataField="numero" dataSort>
                    {' '}
                    Contrato
                  </TableHeaderColumn>
                  <TableHeaderColumn dataField="nome" dataSort>
                    {' '}
                    Cliente
                  </TableHeaderColumn>
                  <TableHeaderColumn dataField="cpf" dataSort>
                    {' '}
                    CPF / CNPJ
                  </TableHeaderColumn>
                </BootstrapTable>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button
              className="btn_success"
              onClick={this.recepcionarProtocolo.bind(this)}
            >
              Finalizar
            </Button>
            <Button
              className="btn_danger"
              onClick={this.openModalFinalizarRecepcao.bind(this)}
            >
              Cancelar
            </Button>
          </ModalFooter>
        </Modal>

        <Row className="not-print">
          <Col sm={12} md={7}>
            <Card>
              <CardHeader>
                Número do Protocolo:{' '}
                <strong>{this.state.numero_protocolo}</strong>
                <span className="text-status">
                  Status:{' '}
                  <strong>
                    {this.props.recepcao.descricaoStatus}
                  </strong>
                </span>
              </CardHeader>
              <CardBody>
                { this.props.recepcao.idProtocolo && (
                  <FiltroDinamico
                    name="recepcionarbusca"
                    service="protocolo"
                    defaultFilters={{"idProtocolo": this.props.recepcao.idProtocolo}}
                    autoSelect={[0]}
                  />
                )}
                  <div>
                    <Row className="mt-3 row_protocolo">
                      <Col>
                      <GridDinamico
                          pagination={false}
                          onSelectRow={true}
                          customTrCss={this.cssRowColors}
                          tableActions={[{type: 'checkbox', disabled: (row) => row.Recepcionado}]}
                          hiddenActions={true}
                          autoSelect={[0]}
                      />
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6} className="text-left">
                        <div className="legenda">
                          <div className="contrato_selecionado"></div>{' '}
                          <span>Contrato Selecionado</span>
                        </div>
                        <div className="legenda">
                          <div className="contrato_recepcionado"></div>{' '}
                          <span>Contrato Recepcionado</span>
                        </div>
                      </Col>
                      <Col md={6} className="text-right">
                        <Button
                          color="btn btn-primary"
                          onClick={() => this.recepcionar()}
                        >
                          Recepcionar
                        </Button>
                      </Col>
                    </Row>
                  </div>
              </CardBody>
            </Card>
          </Col>

          <Col sm={12} md={5} style={{ flexBasis: 'auto' }}>
            <Card>
              <CardHeader>
                Quantidade de Contratos Recepcionados:{' '}
                <strong>
                  {this.state.contratosRecepcionados.length}/
                  {this.props.recepcao.totalContratos
                    ? this.props.recepcao.totalContratos
                    : 0}
                </strong>
              </CardHeader>
              <CardBody>
                <Card className="collapse-custom">
                  <CardHeader
                    id="headingOne"
                    className={this.state.show_recepcionados ? 'selected' : ''}
                    onClick={() => this.toggleShowRecepcionados()}
                  >
                    <Button
                      block
                      color="link"
                      className="text-left m-0 p-0"
                      aria-expanded={this.state.show_recepcionados}
                      aria-controls="collapseOne"
                    >
                      <h5 className="m-0 p-0">Contratos já Recepcionados</h5>
                      <i
                        className={`fa ${
                          this.state.show_recepcionados
                            ? 'fa-arrow-up'
                            : 'fa-arrow-down'
                        }`}
                      ></i>
                    </Button>
                  </CardHeader>
                  <Collapse
                    isOpen={this.state.show_recepcionados}
                    data-parent="#accordion"
                    id="collapseOne"
                    aria-labelledby="headingOne"
                  >
                    <CardBody>
                      <Row className="row_protocolo">
                        <Col>
                          <GridDinamico
                              name="cesta"
                              data={this.state.contratosRecepcionados}
                              pagination={false}
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Collapse>
                </Card>

                <form ref={element => (this.buscaForm = element)}>
                  <Row className="mt-2">
                    <Col md={6}>
                      <Label>N° Caixa Original</Label>
                      <Input
                        innerRef={element => (this.caixa_original = element)}
                        name="caixa_original"
                        type="text"
                        className="form-control"
                        placeholder="Caixa Original"
                      />
                    </Col>

                    <Col md={6}>
                      <Label>N° Caixa Cópia</Label>
                      <Input
                        innerRef={element => (this.caixa_copia = element)}
                        name="caixa_copia"
                        type="text"
                        className="form-control"
                        placeholder="Caixa Cópia"
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col sm={2} md={3} lg={6}>
                      <Label>Responsável Preparação</Label>
                      <Select
                      value={responsaveis}
                      placeholder="Selecione..."
                      onChange={(e) => {this.setState({responsaveis: e})}}
                      options={usuarios}
                      />
                    </Col>

                    <Col md={6}>
                      <Label>Total de Páginas</Label>
                      <Input
                        type="text"
                        disabled
                        className="form-control"
                        value={this.state.totalPaginas}
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col md={12} className="text-right">
                    <Button
                        color="btn btn_success"
                        onClick={() => this.finalizarRecepcao()}
                      >
                        Finalizar Recepção
                      </Button>
                    </Col>
                  </Row>
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  data: state.recepcaoContratos,
  recepcao: state.recepcaoReducer,
  userData: state.auth,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(RecepcaoContratosActions, dispatch),
  recepcaoActions: bindActionCreators(RecepcionarActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RecepcaoContrato);
